import { memo } from 'react';

import classes from './MarginSummary.module.scss';
import marginIcon from './margin-chart.svg';

interface MarginSummaryProps {
  title: string;
  legend: string;
  last12Months: string;
  allTime: string;
  testId: string;
}

const MarginSummary = ({ title, legend, last12Months, allTime, testId }: MarginSummaryProps): JSX.Element => (
  <div className={classes.marginSummary} data-testid={testId}>
    <h4 className="heading">
      <img src={marginIcon} alt="" />
      {title}
    </h4>
    <p className="legend">{legend}</p>
    <div className="window">
      <span className="period">Last 12 Months</span>
      <span className="amount" data-testid={`${testId}-12-months`}>{last12Months}</span>
    </div>
    <div className="window">
      <span className="period">All Time</span>
      <span className="amount" data-testid={`${testId}-all-time`}>{allTime}</span>
    </div>
  </div>
);

export default memo(MarginSummary);
